export const LOAD_CLOCK_TASK_BY_ID = 'LOAD_CLOCK_TASK_BY_ID';
export const LOAD_PROJECT_BY_ID = 'LOAD_PROJECT_BY_ID';
export const START_CLOCK_BY_TASK_ID = 'START_CLOCK_BY_TASK_ID';
export const STOP_CLOCK_BY_TASK_ID = 'STOP_CLOCK_BY_TASK_ID';
export const GET_PROJECTS_BY_USER_ID = 'GET_PROJECTS_BY_USER_ID';
export const GET_PROJECTS_BY_USER_ID_FAILED = 'GET_PROJECTS_BY_USER_ID_FAILED';

export function loadClockTaskById(data) {
  return {
    type: LOAD_CLOCK_TASK_BY_ID,
    payload: data,
  }
}

export function loadProjectById(data) {
    return {
      type: LOAD_PROJECT_BY_ID,
      payload: data,
    }
}

export function startClockByTaskId(data) {
    return {
        type: START_CLOCK_BY_TASK_ID,
        payload: data,
    }
}

export function stopClockByTaskId(data) {
    return {
        type: STOP_CLOCK_BY_TASK_ID,
        payload: data,
    }
}

export function getProjectsByUserId(data) {
  return {
    type: GET_PROJECTS_BY_USER_ID,
    payload: { list: data }
  }
}

export function getProjectsByUserIdFailed(data) {
    return {
      type: GET_PROJECTS_BY_USER_ID_FAILED,
      payload: data
    }
  }





// WEBPACK FOOTER //
// ./src/actions/taskClock/index.js